import React from 'react';
import {
  UAPPlacementTypeAlias as EPT,
  UAPLPlacementMetaList,
} from '@bingads-webui-campaign-react/unified-ad-preview-library-core';

import EdgeAdImageSrc from '../media/edge-ad-image.jpg';
import MSNAdImageSrc from '../media/msn-ad-image.jpg';
import {
  SearchBadgeIcon,
  SearchChannelIcon,
  EdgeBadgeIcon,
  EdgeChannelIcon,
  MSNBadgeIcon,
  MSNChannelIcon,
  OutlookBadgeIcon,
  OutlookChannelIcon,
} from './icons';

export const AdPlacementTypeList = [
  EPT.Responsive.MSAN.MSEdgeSingleCarousel,
  EPT.Responsive.BingSearch.Text,
  EPT.Responsive.MMA.LandscapeImage,
  EPT.Responsive.Outlook.Mobile,
];

export const TextAdPlacementList = [{
  placementMeta: UAPLPlacementMetaList[EPT.Responsive.BingSearch.Text],
  imageMeta: {},
}, {
  placementMeta: UAPLPlacementMetaList[EPT.Responsive.Outlook.Mobile],
  imageMeta: {},
}];

export const AdPlacementList = [{
  placementMeta: UAPLPlacementMetaList[EPT.Responsive.MSAN.MSEdgeSingleCarousel],
  imageMeta: {
    url: EdgeAdImageSrc,
    originalWidth: 410,
    originalHeight: 220,
  },
}, {
  placementMeta: UAPLPlacementMetaList[EPT.Responsive.BingSearch.Text],
  imageMeta: {},
}, {
  placementMeta: UAPLPlacementMetaList[EPT.Responsive.MMA.LandscapeImage],
  imageMeta: {
    url: MSNAdImageSrc,
    originalWidth: 410,
    originalHeight: 220,
  },
}, {
  placementMeta: UAPLPlacementMetaList[EPT.Responsive.Outlook.Mobile],
  imageMeta: {},
}];

export const AdChannelMapping = {
  [EPT.Responsive.MSAN.MSEdgeSingleCarousel]: {
    badgeText: _TL_('Display ads on Edge'),
    onRenderBadgeIcon: () => <EdgeBadgeIcon />,
    onRenderChannelIcon: () => <EdgeChannelIcon />,
  },
  [EPT.Responsive.BingSearch.Text]: {
    badgeText: _TL_('Search ad on Bing'),
    onRenderBadgeIcon: () => <SearchBadgeIcon />,
    onRenderChannelIcon: () => <SearchChannelIcon />,
  },
  [EPT.Responsive.MMA.LandscapeImage]: {
    badgeText: _TL_('Display ads on MSN'),
    onRenderBadgeIcon: () => <MSNBadgeIcon />,
    onRenderChannelIcon: () => <MSNChannelIcon />,
  },
  [EPT.Responsive.Outlook.Mobile]: {
    badgeText: _TL_('Outlook ads'),
    onRenderBadgeIcon: () => <OutlookBadgeIcon />,
    onRenderChannelIcon: () => <OutlookChannelIcon />,
  },
};

export const getAdChannelForPlacement = placementType => AdChannelMapping[placementType];

export const ExtraPlacementInfoMapping = {
  [EPT.Responsive.MSAN.MSEdgeSingleCarousel]: {
    imagePreviewHeight: 220,
  },
  [EPT.Responsive.MMA.LandscapeImage]: {
    imagePreviewHeight: 180,
  },
};

export const getExtraPlacementInfo = placementType => ExtraPlacementInfoMapping[placementType];

export const AdsDataMapping = {
  [EPT.Responsive.MSAN.MSEdgeSingleCarousel]: {
    shortHeadline: 'Order Online Today & Save',
    businessName: 'Contoso flower',
  },
  [EPT.Responsive.BingSearch.Text]: {
    allShortHeadlines: ['Premium Dinnerware For Less', 'Order Online Today & Save'],
    description: 'Explore our expansive selection of unique, custom-crafted options, perfectly aligning with every style and budget, tailored exclusively for you.',
    displayUrl: 'www.contoso.com',
    isClickDisabled: true,
  },
  [EPT.Responsive.MMA.LandscapeImage]: {
    shortHeadline: 'Freshly Baked Bliss',
    businessName: 'Contoso bread',
    displayUrl: 'contosobread.com',
  },
  [EPT.Responsive.Outlook.Mobile]: {
    shortHeadline: 'Free fitness plan that will help you to live life to the fullest.',
    description: 'Complete your personalised fitness plan.',
    businessName: 'Customizable Fitness Plans',
  },
};

export const getAdDataForPlacement = placementType => AdsDataMapping[placementType];
